import { Currency, LanguageConfig } from './language.config';

export class FrenchConfig extends LanguageConfig {
  constructor() {
    super();
    this.units = [
      '',
      'Un',
      'Deux',
      'Trois',
      'Quatre',
      'Cinq',
      'Six',
      'Sept',
      'Huit',
      'Neuf',
    ];
    this.teens = [
      'Dix',
      'Onze',
      'Douze',
      'Treize',
      'Quatorze',
      'Quinze',
      'Seize',
      'Dix-Sept',
      'Dix-Huit',
      'Dix-Neuf',
    ];
    this.tens = [
      '',
      'Dix',
      'Vingt',
      'Trente',
      'Quarante',
      'Cinquante',
      'Soixante',
      'Soixante-Dix',
      'Quatre-Vingt',
      'Quatre-Vingt-Dix',
    ];
    this.scales = ['', 'Mille', 'Million', 'Milliard'];
    this.zeroWord = 'Zéro';
    this.decimalConnector = 'et';
    this.specialCases = {
      70: 'Soixante-Dix',
      71: 'Soixante-et-Onze',
      80: 'Quatre-Vingts',
      90: 'Quatre-Vingt-Dix',
    };
    this.currencyPluralization = (
      currency: Currency,
      amount: number,
    ): string => {
      if (amount !== 1) {
        if (currency === 'Franc CFA') return 'Francs CFA';
      }
      return currency;
    };
    this.fractionalUnit = (currency: Currency, amount: number): string => {
      if (currency === 'Franc CFA')
        return amount !== 1 ? 'Centimes' : 'Centime';
      return amount !== 1 ? 'Cents' : 'Cent';
    };
  }

  protected getHundreds(hundreds: number): string {
    if (hundreds === 1) return 'Cent';
    return `${this.units[hundreds]} Cent`;
  }
}
